import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ModalOptions} from '@ionic/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(
    private modalController: ModalController,
  ) {
  }

  async openModal(component, componentProps = {}, options: Partial<ModalOptions> = {}) {
    const modalOptions: ModalOptions = {
      component,
      componentProps,
      cssClass: 'auto-height',
      ...options,
    };

    const modal = await this.modalController.create(modalOptions);
    await modal.present();
    return modal;
  }

  async dismiss(data?, role?) {
    try {
      await this.modalController.dismiss(data, role);
    } catch (error) {}
  }
}
